import { default as styled } from 'styled-components';

/** Same surface language as InfoModal / Dot modal content — theme white card, not legacy aeroBlue panel. */
export const Instruction = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  max-width: min(90%, 420px);
  padding: 24px 28px;
  border-radius: 16px;
  color: ${(p) => p.theme.colors.oxfordBlue[100]};
  background: ${(p) => p.theme.colors.white};
  box-shadow: 0 8px 32px rgba(10, 25, 64, 0.18);
`;

export const Subtitle = styled.p`
  margin: 0.5em 0 0 0;
  color: ${(props) => props.theme.colors.oxfordBlue[80]};
  line-height: 1.4;
`;

export const ButtonRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: center;
  margin-top: 1.25rem;
`;
